import PropTypes from "prop-types";

const Header = ({title, addClassName}) => {
  const concatenatedClassVal = addClassName
    ? "header " + addClassName
    : "header";

  return (
    <header className={concatenatedClassVal}>
      <div className="input-cell">
        <h1>{title}</h1>
      </div>
    </header>
  );
};

export default Header;
